import * as S from './Loading.style';

function Loading() {
  return (
    <S.Container>
      <S.Dots role="alert" aria-busy="true">
        <span />
        <span />
        <span />
      </S.Dots>
    </S.Container>
  );
}

export default Loading;
